export default "__VITE_ASSET__CiGokPH7__"